module.exports = __webpack_public_path__ + "static/human-1-c812f4254fe90d1055b24978b226b40d.png";